import { EmbeddedReport } from "@/types/EmbedReportListItem";
import ApiConnector from "../apiConnector";
import { PageDescription } from "@/types/PageDescriptionListItem";

class AzureGraphDataFetcher {
    private readonly apiConnector: ApiConnector;

    constructor(token: string) {
        this.apiConnector = new ApiConnector("https://graph.microsoft.com/v1.0/", token);
    }
    public async getUserManager(id: string): Promise<any> {
        return await this.apiConnector.get<any>(`users/${id}/manager`);
    }

    public async getMyPhoto(): Promise<any> {
        return await this.apiConnector.getBlob<any>("me/photo/$value");
    }
    
    public async isCurrentUserMemberOfGroup(): Promise<boolean> {
        const response = await this.apiConnector.get<any>(
        "me/memberOf?$filter=id eq '6667da17-18d7-4449-99ae-8f78ef9b3746'"
        );
        return response && response.value && response.value.length > 0;
    }
    
    public async getPageDescription(id: string): Promise<any> {
        const headers = { 'Prefer': 'HonorNonIndexedQueriesWarningMayFailRandomly' };
        return await this.apiConnector.get<PageDescription | undefined>(`sites/abb.sharepoint.com,34363488-3376-463d-a1c2-59baf4ccf50c,19c5a9f0-f517-44ff-80fb-5f3abadd8c23/lists/25045fb6-cbbf-471d-9cce-576821320a22/items/${id}`, headers);
    }

    public async getReportLink(reportName: string): Promise<any> {
        const headers = { 'Prefer': 'HonorNonIndexedQueriesWarningMayFailRandomly' };
        return await this.apiConnector.get<any>(`sites/abb.sharepoint.com,34363488-3376-463d-a1c2-59baf4ccf50c,81bf171d-b6d4-4a0e-b078-a5972911c831/lists/cba55c41-3a17-4dfc-a968-2ac15e54bb86/items?$filter=fields/Url eq '${reportName}'&$expand=fields`, headers);
    }
}

export default AzureGraphDataFetcher;
